'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _checkNetworkOnTimeout = require('../decorators/checkNetworkOnTimeout');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noAuthApiClient = {
  post: (0, _checkNetworkOnTimeout.checkNetworkOnTimeout)(_noAuthApiClient2.default.post),
  put: (0, _checkNetworkOnTimeout.checkNetworkOnTimeout)(_noAuthApiClient2.default.put),
  get: (0, _checkNetworkOnTimeout.checkNetworkOnTimeout)(_noAuthApiClient2.default.get),
  getWithResponse: (0, _checkNetworkOnTimeout.checkNetworkOnTimeout)(_noAuthApiClient2.default.getWithResponse),
  delete: (0, _checkNetworkOnTimeout.checkNetworkOnTimeout)(_noAuthApiClient2.default.delete)
};

exports.default = noAuthApiClient;
module.exports = exports['default'];